import { Component, OnInit, Input, SimpleChanges } from '@angular/core'
import { Preview } from './preview'
import { GalleryService } from './gallery.service'
import { AngularFireDatabase } from 'angularfire2/database'

declare var blueimp: any

@Component({
	selector: 'app-gallery',
	templateUrl: './gallery.component.html',
	styleUrls: ['./gallery.component.scss']
})

export class GalleryComponent implements OnInit {

	@Input() files: Array<any>
	@Input() canSeeChat: boolean
	@Input() canapprove: boolean
	previews: Array<Preview>
	gallery: any
	current: Preview
	showChat: boolean = false

	constructor(
		public gs: GalleryService,
		private db: AngularFireDatabase,
	) {
		this.gs.request.subscribe(index => this.open(index as number))
	}

	ngOnInit() {}

	ngOnChanges(changes: SimpleChanges) {
		if (!changes.files) return
		let files = changes.files.currentValue
		this.previews = []
		for(let i in files) {
			let file = files[i]
			// Skip preview if no dimensions
			// if (file.name.match(/\d+x\d+/))
				this.previews.push(new Preview(file, i))
		}
	}

	toggleChat(event) {
		event.preventDefault()
		this.showChat = !this.showChat
	}

	open(index: number) {
		if (this.previews[index] && this.previews[index].file && this.previews[index].file.messages_count && this.previews[index].file.messages_count.flag > 0)
			this.showChat = true

		this.gallery = blueimp.Gallery(this.previews, {
			index: index,
			toggleControlsOnReturn: false,
			toggleControlsOnSlideClick: false,
			toggleSlideshowOnSpace: false,
			hidePageScrollbars: false,
			slideshowInterval: 999999,
			// Approve creative when clicking "A"
			onopened: () => {
				window.onkeyup = (e) => {
					if (!this.canapprove || ((e.target as HTMLElement) && (e.target as HTMLElement).tagName == 'INPUT')) return
					var charCode = (typeof e.which == "number") ? e.which : e.keyCode
					if (String.fromCharCode(charCode) == "A") {
						this.gallery.container[0].querySelector('#file-approve').click()
					}
				};
			},
			onclose: () => {
				window.onkeyup = function() {}
			},
			onslide: (index, slide) => {
				this.previews[index].onslide(slide)
				this.current = this.previews[index]

				// if (this.current.file && this.current.file.messages_count && this.current.file.messages_count.flag > 1)
				// 	this.showChat = true
			},
			onslideend: (index, slide) => {
				// Stop banners on slide leaving screen
				if (this.previews[index+1] && this.previews[index+1].type.indexOf('text') == 0 && slide.nextSibling)
							slide.nextSibling.querySelector('iFrame').src = ''
				if (this.previews[index-1] && this.previews[index-1].type.indexOf('text') == 0 && slide.previousSibling)
							slide.previousSibling.querySelector('iFrame').src = ''
			},
		})
	}

	refresh(event) {
		event.preventDefault()
		let slide = this.gallery.slides[this.gallery.index]
		slide.querySelector('iFrame').contentWindow.location.href = this.current.href + '?rand=' + Math.random()
	}

	onApprove($event) {
		// To do : do it via Folder.service. But for now, can't import because of circulary dependency
		let folder_id = this.current.file.folder.replace(/^(uploads\/)/, '')
		this.current.approved = !this.current.approved
		this.db.object(['folders', folder_id, 'files', this.current.file.id, 'approved'].join('/')).set(this.current.approved)
		// this.FolderService()
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/gallery/gallery.component.ts